import { BionicNavigation } from '@/assets/js/constants/navigation'
import { defineNuxtRouteMiddleware, useNuxtApp } from 'nuxt/app'

export default defineNuxtRouteMiddleware((to, from) => {
  const { $pageTitle, $filters } = useNuxtApp()

  // manageType will already set its own page title
  if (to.name === 'manage-manageType') return

  const navItem = BionicNavigation.find((item) => {
    return item.link === to.path || item.link === to.fullPath
  })

  if (navItem) {
    $pageTitle(navItem.text, true)
  } else {
    const paths = to.path
      .split('/')
      .filter((part) => part)
      .map($filters.convertFromCapsKebab)

    $pageTitle(paths[paths.length - 1], true)
  }
})
